import React, { useEffect } from 'react';
import { func, shape, string } from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { enqueueSnackbar } from '../../actions/applicationMessageActions';

const UnauthorizedPage = ({ enqueueSnackbar, history, location, message }) => {
    const dispatch = useDispatch();

    const snackMessage = message || 'You do not have permission to view this page.';

    useEffect(() => {
        dispatch(
            enqueueSnackbar(
                snackMessage,
                'warning'
            )
        );
    }, []);

    return (
        <Redirect
            to={{
                pathname: '/myaccount',
                search:   location.search,
                state:    { from: location }
            }}
        />
    );
};

UnauthorizedPage.defaultProps = {
    enqueueSnackbar
};

UnauthorizedPage.propTypes = {
    enqueueSnackbar: func,
    history:         shape({
        push: func
    }),
    location: shape({
        search: string
    })
};

export default withRouter(UnauthorizedPage);
